module.exports = __webpack_public_path__ + "static/img/img-6.e3c223e6.png";